(() => {
  'use strict';
  const key = 'wings.theme';
  const root = document.documentElement;
  const defaultTheme = root.dataset.defaultTheme === 'a' ? 'a' : 'b';
  const valid = value => value === 'a' || value === 'b';
  let theme = valid(root.dataset.theme) ? root.dataset.theme : defaultTheme;
  function apply(value) {
    theme = valid(value) ? value : defaultTheme;
    root.dataset.theme = theme;
    document.body.dataset.theme = theme;
    document.querySelectorAll('[data-look-choice]').forEach(input => { input.checked = input.value === theme; });
    document.dispatchEvent(new CustomEvent('wings:look-changed', { detail: { theme } }));
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-look-choice]') || !valid(event.target.value)) return;
    apply(event.target.value);
    try { localStorage.setItem(key, theme); } catch { /* Keep the selection in this tab. */ }
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    try { if (event.storageArea !== window.localStorage) return; } catch { return; }
    apply(event.newValue);
  });
  document.addEventListener('shopify:section:load', () => apply(theme));
  apply(theme);
})();
